<template>
  <div>
    <label class="ux-field-title" v-if="showLabel"
      >{{ label }}
      <span class="ux-required-marker" v-if="required">*</span></label
    >
    <div class="ux-field-description" v-if="showDescription">
      {{ description }}
    </div>
    <div v-if="multiValue">
      <div class="ux-location-row" :key="index" v-for="(entry, index) in model">
        <div class="location-field-wrap">
          <flex-row gap center>
            <flex-cell>
              <location-search
                :deselectEnabled="canRemoveValue"
                @deselect="checkRemoveEntry(entry, index)"
                v-model="model[index]"
                v-model:advanced="multiAdvancedOptions[index]"
                show-advanced-toggle
              />
            </flex-cell>
            <!-- <flex-cell shrink v-if="!entry.addressLine1 || (!entry.latitude && !entry.longitude)" >
              <ux-button
                tag="a"
                @click="
                  multiAdvancedOptions[index] = !multiAdvancedOptions[index]
                "
              >
                {{ multiAdvancedOptions[index] ? "Less N" : "More N" }}
                <ux-icon
                  :icon="
                    multiAdvancedOptions[index]
                      ? 'fa-angle-up'
                      : 'fa-angle-down'
                  "
                />
              </ux-button>
            </flex-cell> -->
            <flex-cell
              shrink
              v-if="canRemoveValue && !(entry.latitude && entry.longitude)"
            >
              <ux-button tag="a" icon @click="remove(entry)">
                <ux-icon icon="fa-times" />
              </ux-button>
            </flex-cell>
          </flex-row>

          <div
            class="teleport-results"
            :id="`teleport-${multipleTeleportIDs[index]}`"
          />

          <template v-if="multiAdvancedOptions[index]">
            <location-select
              @focus="touch"
              ref="input"
              v-model="model[index]"
              class="ux-location-select ux-field-focus ux-location-multiple"
            />
          </template>
        </div>
      </div>
      <ux-button v-if="canAddValue" @click="add()"
        >{{ addLabel }} <ux-icon icon="fa-plus" right
      /></ux-button>
    </div>
    <div class="location-field-wrap" v-else>
      <flex-row>
        <flex-cell>
          <!-- :teleportID="singleTeleportID" -->
          <location-search
            @deselect="checkRemoveEntry"
            v-model="model"
            v-model:advanced="singleAdvancedOptions"
            show-advanced-toggle
          />
          <div class="teleport-results" :id="`teleport-${singleTeleportID}`" />
          <template v-if="singleAdvancedOptions">
            <location-select
              :assumeDefault="!!field.assumeDefault"
              class="ux-location-select ux-field-focus ux-location-single"
              ref="input"
              @focus="touch"
              v-model="model"
            />
          </template>
        </flex-cell>
        <!-- <flex-cell shrink>
                                <ux-button tag="a" icon  @click="toggleAdvancedOptions">
                                    {{showAdvancedOptions ? 'Less' : 'More'}} <ux-icon :icon="showAdvancedOptions ? 'fa-angle-up' : 'fa-angle-down'" />
                                </ux-button>
                            </flex-cell> -->
        <!-- <flex-cell shrink v-if="canRemoveValue">
                                <ux-button tag="a" icon  @click="removeValue()">
                                    <ux-icon icon="fa-times" />
                                </ux-button>
                            </flex-cell> -->
      </flex-row>
    </div>
  </div>
</template>
<script>
import LocationSearch from "./location-search.vue";
import LocationSelect from "./location.vue";
import InputMixin from "./input-mixin";

function createDefaultObject() {
  return {
    title: undefined,
    latitude: undefined,
    longitude: undefined,
    addressLine1: undefined,
    addressLine2: undefined,
    suburb: undefined,
    state: undefined,
    country: undefined,
    postalCode: undefined,
    threshold: undefined,
    search: undefined,
  };
}

export default {
  data() {
    return {
      singleAdvancedOptions: false,
      multiAdvancedOptions: {},
    };
  },
  components: {
    LocationSelect,
    LocationSearch,
  },
  props: {
    modelValue: {
      type: [Object, Array],
    },
  },
  created() {
    console.log("CREATED LOCATION");
    if (!this.model) {
      if (this.singleValue) {
        this.model = createDefaultObject();
      }
    }
  },
  mixins: [InputMixin],
  computed: {
    singleTeleportID() {
      const min = 1;
      const max = 10000;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    multipleTeleportIDs() {
      const self = this;
      return self.model.map(function (id, i) {
        return `${self.singleTeleportID}-${i}`;
      });
    },
  },
  methods: {
    refocus() {
      const searchInput = this.$el.querySelector(".search input");
      if (searchInput) {
        searchInput.focus();
        console.log("foxys");
      }
    },
    checkRemoveEntry(entry, index) {
      if (this.singleValue) {
        this.singleAdvancedOptions = false;
        return;
      }
      if (!this.canRemoveValue) {
        return;
      }

      this.remove(entry);
    },
    removeValue() {
      this.model = this.getNewDefaultEntry();
      this.dispatch();
    },
    getNewDefaultEntry() {
      return createDefaultObject();
    },
  },
};
</script>
<style lang="scss" scoped>
.teleport-results {
  position: relative;
  margin-bottom: 0.5em;
}
// .location-field-wrap {
// display: flex;
// min-height: 300px;
// }

// .location-search-outer {
// margin-bottom: 0.5em;
// }
</style>
